import { render } from "./AlarmCenter.vue?vue&type=template&id=aa9553b2&scoped=true"
import script from "./AlarmCenter.vue?vue&type=script&lang=js"
export * from "./AlarmCenter.vue?vue&type=script&lang=js"

import "./AlarmCenter.vue?vue&type=style&index=0&id=aa9553b2&scoped=true&lang=css"

import exportComponent from "D:\\Workspace-idea\\vue-space\\hwoms-vue\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-aa9553b2"]])

export default __exports__